import React, { useContext } from 'react';
import MainHome from '../components/HomeMainSec';
import AboutHome from '../components/AboutHome';
import ExpEduHome from '../components/ExpEduHome';
import PortfolioHome from '../components/PortfolioHome';
import SkillsHome from '../components/SkillsHome';
import ContactHome from '../components/ContactHome';
import { useSelector } from 'react-redux';
import { contextpass } from '../App';
import { Helmet } from 'react-helmet';

function Home() {
	// const ScrollReveal = require("scrollreveal");

	const count = useSelector((state) => state.counter.value);
	const { pass } = useContext(contextpass);
	const [mode] = pass;
	// console.log(pass);
	switch (count) {
		case 1:
			// var element1 = document.getElementById("sec1");
			// element1.scrollIntoView();

			const element1 = document.getElementById('sec1');
			if (element1) {
				element1.scrollIntoView({ behavior: 'smooth' });
			}
			break;
		case 2:
			const element2 = document.getElementById('sec2');
			if (element2) {
				element2.scrollIntoView({ behavior: 'smooth' });
			}
			break;
		case 3:
			const element3 = document.getElementById('sec3');
			if (element3) {
				element3.scrollIntoView({ behavior: 'smooth' });
			}
			break;
		case 4:
			const element4 = document.getElementById('sec4');
			if (element4) {
				element4.scrollIntoView({ behavior: 'smooth' });
			}
			break;
		case 5:
			const element5 = document.getElementById('sec5');
			if (element5) {
				element5.scrollIntoView({ behavior: 'smooth' });
			}
			break;
		case 6:
			const element6 = document.getElementById('sec6');
			if (element6) {
				element6.scrollIntoView({ behavior: 'smooth' });
			}
			break;

		default:
			const elementd = document.getElementById('sec1');
			if (elementd) {
				elementd.scrollIntoView({ behavior: 'smooth' });
			}
			break;
	}
	return (
		<div className="scrollable">
			<Helmet>
				<meta
					name="description"
					content="As a front-end developer, design and development are very important
    to me. I think my technical expertise and sense of aesthetics make
    me a well-rounded developer who can handle any challenge."
				/>
				<title>Muhammed Mubashir - Web Developer | Front-end Developer | UI Designer</title>
			</Helmet>
			<section className={mode === true ? 'align-items-center row bg-6' : 'align-items-center row bg-1'} id="sec1">
				<MainHome />
			</section>
			<section className={mode === true ? 'align-items-center row bg-6 rev' : 'align-items-center row bg-2 rev'} id="sec2">
				<AboutHome />
			</section>
			<section className={mode === true ? 'align-items-center row bg-6 rev1' : 'align-items-center row bg-3 rev1'} id="sec3">
				<ExpEduHome />
			</section>
			<section className={mode === true ? 'align-items-center row bg-6' : 'align-items-center row bg-4'} id="sec4">
				<PortfolioHome />
			</section>
			<section className={mode === true ? 'align-items-center row bg-6' : 'align-items-center row bg-5'} id="sec5">
				<SkillsHome />
			</section>
			<section className={mode === true ? 'align-items-center row bg-6' : 'align-items-center row bg-6'} id="sec6">
				<ContactHome />
			</section>
		</div>
	);
}

export default Home;
